// extracted by mini-css-extract-plugin
var _1 = "M1cQ1Tlp2ky5mUgAbg1K";
var _2 = "SgWxwNqMOiyYkbfcpo7r";
export { _1 as "item", _2 as "list" }
